import { compareTranslatedValue } from "utils/lang";

export const getFileExtensionWithDot = (filename: string) => {
  const parts = filename.split(".");
  return parts.length > 1 ? `.${parts.pop()}` : "";
};


export const getAmountWageLabel = (wage: string) => {
  const isHourly = compareTranslatedValue(wage, 'hourly');
  return isHourly ? 'dollar_per_hour' : 'gross_income'
}

export const getFieldLabelByHouseHold = (isMainApplier: boolean, mainApplicantLabel: string, dependentApplicantLabel: string) => {
  return isMainApplier ? mainApplicantLabel : dependentApplicantLabel
}

export const formatPossessive = (name: string) => {
  return `${name}'s`;
}

